import { ICellRendererParams } from 'ag-grid-community';
import { FunctionComponent } from 'react';
import { TransactionModel } from '../../types/TransactionModel';
import { TransactionSource } from '../../api/transactions/transaction.contracts';
import { useTranslation } from '@/lib';

export const TransactionSourceCellRenderer: FunctionComponent<ICellRendererParams<TransactionModel>> = (params) => {
  const { t } = useTranslation();

  if (!params.data) {
    return null;
  }

  const source = params.data.source;

  // Get label based on source
  const getSourceLabel = () => {
    switch (source) {
      case TransactionSource.Manual:
        return t('manual');
      case TransactionSource.Automatic:
        return t('automatic');
      default:
        return t('unknown');
    }
  };

  // Get color classes based on source
  const getColorClasses = () => {
    switch (source) {
      case TransactionSource.Manual:
        return {
          bg: 'bg-indigo-100 dark:bg-indigo-500/20',
          text: 'text-indigo-800 dark:text-indigo-300',
        };
      case TransactionSource.Automatic:
        return {
          bg: 'bg-cyan-100 dark:bg-cyan-500/20',
          text: 'text-cyan-800 dark:text-cyan-300',
        };
      default:
        return {
          bg: 'bg-gray-100 dark:bg-gray-500/20',
          text: 'text-gray-800 dark:text-gray-300',
        };
    }
  };

  const colorClasses = getColorClasses();

  return (
    <div className="flex h-full items-center">
      <span className={`inline-flex rounded-md px-3 py-1 mt-1 text-xs font-semibold ${colorClasses.bg} ${colorClasses.text}`}>
        {getSourceLabel()}
      </span>
    </div>
  );
};
